/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import type { TView } from '@shared/types/view';
import type { ColumnPinningState } from '@tanstack/react-table';
import type { Updater } from '@tanstack/react-table';
import { isEqual } from 'lodash';

const createPinning = (pinning: ColumnPinningState) => {
  const leftPining = (pinning?.left || []).filter((c) => c !== 'select');
  const rightPining = (pinning?.right || []).filter((c) => c !== 'actions');
  const newPinning = {
    left: ['select', ...leftPining],
    right: ['actions', ...rightPining],
  };
  return newPinning;
};

export const useColumnPinning = (view?: TView) => {
  const pinningFromView = createPinning(
    view?.visible_static_fields.pinning || {}
  );

  const [columnPinning, setColumnPinning] = useState(pinningFromView);

  useEffect(() => {
    setColumnPinning(pinningFromView);
  }, [JSON.stringify(view?.visible_static_fields.pinning)]);

  function onColumnPinningChange(updaterOrValue: Updater<ColumnPinningState>) {
    const pinning =
      typeof updaterOrValue === 'function'
        ? updaterOrValue(columnPinning || {})
        : updaterOrValue;

    const newPinning = createPinning(pinning);
    setColumnPinning(newPinning);
  }

  const isColumnPinningChanged = !isEqual(columnPinning, pinningFromView);

  return {
    columnPinning,
    onColumnPinningChange,
    isColumnPinningChanged,
  };
};
